// 持分くん: 全画面ドロワー（ハンバーガー）。HTML: .js-headerToggle / .js-headerDrawer / .l-header
// 状態クラス: .l-header.is-drawerOpen（CSS が opacity / hamburger→× を制御）。
export function initDrawer() {
  const toggle = document.querySelector('.js-headerToggle');
  const header = document.querySelector('.js-header');
  if (!toggle || !header) return;

  const label = toggle.querySelector('.js-headerToggle-text');
  const drawer = header.querySelector('.js-headerDrawer');

  const close = () => {
    header.classList.remove('is-drawerOpen');
    toggle.setAttribute('aria-expanded', 'false');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
    }
    if (label) label.textContent = 'MENU';
    document.body.classList.remove('is-drawerOpen');
  };
  const open = () => {
    header.classList.add('is-drawerOpen');
    toggle.setAttribute('aria-expanded', 'true');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
    }
    if (label) label.textContent = 'CLOSE';
    document.body.classList.add('is-drawerOpen');
  };

  toggle.addEventListener('click', () => {
    header.classList.contains('is-drawerOpen') ? close() : open();
  });

  if (drawer) {
    drawer.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', close);
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && header.classList.contains('is-drawerOpen')) {
      close();
      toggle.focus();
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1100 && header.classList.contains('is-drawerOpen')) {
      close();
    }
  });
}
